import React, { useState } from 'react';
import styles from './BCRInformation.module.scss';
import dropdownArrowLight from '../../../assets/images/LightTheme/down_arrow_light.svg';
import dropdownArrowDark from '../../../assets/images/DarkTheme/down_arrow_dark.svg';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../redux/hooks';
import HATVBCRInfo from '../../HATV/HATVBCRInfo/HATVBCRInfo';
import { useProfileParams } from '../../../utils/common';
import { useGetHATVBCRInfoListQuery } from '../../../redux/services/hatvQmonthUplineImpactAPI';
import { isValidResponse } from '../../../utils/validateAPIResponse';

const BCRInformation = () => {
  const { t } = useTranslation();
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const dropdownArrow = currentTheme === 'light' ? dropdownArrowLight : dropdownArrowDark;
  const [isContentVisible, setIsContentVisible] = useState<boolean>(false);

  const { affiliateCode, aboNumber } = useProfileParams();
  const { data, isLoading } = useGetHATVBCRInfoListQuery(
    { affiliateCode, aboNumber },
    {
      skip: Number(affiliateCode) === 0 || aboNumber === 0,
      refetchOnMountOrArgChange: true,
    }
  );

  const bcrData = isValidResponse(data?.statusCode) ? data?.body || [] : [];

  const handleDropdownClick = () => {
    setIsContentVisible((prev) => !prev);
  };

  return (
    <div className={styles.bcr_info_wrapper}>
      <div
        className={`${styles.section_title_wraper} ${isContentVisible ? styles.content_visible : ''}`}
      >
        <span className={styles.section_title}>{t('BCR_heading')}</span>
        <img
          src={dropdownArrow}
          alt="Dropdown Arrow"
          className={`dropdown_icon ${styles.dropdown_icon} ${isContentVisible ? styles.rotate : ''}`}
          onClick={handleDropdownClick}
          style={{
            cursor: true ? 'pointer' : 'default',
          }}
        />
      </div>
      {isContentVisible && (
        <div className={styles.leader_bcr_infor}>
          <HATVBCRInfo tableData={bcrData} isLoading={isLoading} />
        </div>
      )}
    </div>
  );
};

export default BCRInformation;
